import React from 'react';
import PropTypes from 'prop-types';

import Page from 'components/Page';
import Button, {ModalXButton} from 'components/Button';
import Footer from 'components/Footer';
import Spinner from 'components/Spinner';

import './style.css';

/* eslint-disable max-len */
export const DealFinalizingConfirmation = ({sending, cancel, submit}) => {
  if (sending) {
    return (
      <Page>
        <Spinner />
      </Page>
    );
  }

  return (
    <Page>
      <header styleName="header toplevel">
        <h2 styleName="h2">What happens now?</h2>
        <ModalXButton onClick={cancel} data-test="finalizing_cancel" />
      </header>
      <section styleName="content">
        <p>
          Once you’ve invited all your investors and they’ve committed to invest,
          you can move onto the next phase where you <strong>decide how much
          each of your investors will be contributing</strong> towards the investment - splitting the raise.
        </p>
        <p>When you move onto the next phase:</p>
        <ul>
          <li>You <strong>won’t be able to invite</strong> any more investors</li>
          <li>Anyone, who hasn’t already committed, <strong>won’t be able invest</strong></li>
          <li>Committed investors <strong>won’t be able to change</strong> their investment amount</li>
        </ul>
      </section>
      <Footer styleName="toplevel">
        <Button onClick={submit} data-test="finalizing_submit">
          Split the Raise
        </Button>
      </Footer>
    </Page>
  );
};
/* eslint-enable max-len */

DealFinalizingConfirmation.propTypes = {
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
};

export default DealFinalizingConfirmation;



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealFinalizingConfirmation/component.js